import type { FaireProductEntity } from "../../entity_types/product";

export const p_utcyrq7wr6: FaireProductEntity = {
  token: "p_utcyrq7wr6",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE RED",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/4495ec759a672c4b7a4e3d1d225b22d9fbed4724bde4c5ea91ec08a2ca91c484.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:08.713Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
